import { SingleSelect } from 'Shared/forms/Inputs';
import { LabelOnLeftWrap } from 'Shared/forms/Wrap';
import { StyleFieldsRow } from 'Shared/backend/styles/StyleFieldsRow';


export const widthOptions = {
	auto: 'Auto',
	full: 'Full width',
};


export function Width()
{
	return (
		<StyleFieldsRow>
			<WidthFields />
		</StyleFieldsRow>
	);
}


/* The width on its own, for a caller that names the location itself - see ruleProperties(). 'full'
   is width:100%; 'auto' contributes nothing. */
export function WidthFields()
{
	return (
		<LabelOnLeftWrap label='' narrow={true}>
			<SingleSelect field='width' options={widthOptions} />
		</LabelOnLeftWrap>
	);
}
